import { makeStyles } from '@material-ui/core';

export const DRAWER_WIDTH = 236;
export const MOBILE_TOOLBAR_HEIGHT = '62px';

const useNeoWrapperStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh'
  },
  appbar: {
    maxWidth: '100%',
    boxShadow: 'none',
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${DRAWER_WIDTH}px) !important`,
      marginLeft: DRAWER_WIDTH
    },
    backgroundColor: '#004B6C !important',
  },
  contentContainer: {
    flexGrow: 1,
    backgroundColor: theme.palette.common.white,
    margin: '80px 0px 0px'
  },
  content: {
    position: 'relative',
    minHeight: 'calc(100% - 80px)',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'calc(100% - 60px)',
      maxWidth: '100vw',
    }
  },
  contentInner: {
    padding: '38px 30px 100px',
    maxWidth: '860px',
    margin: 'auto'
  },
  toolbar: {
    height: '80px',
    padding: '0',
    borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    margin: 'auto 0',
    minHeight: '76px !important',
    overflow: 'visible'
  },
  eSignContent: {
    flexGrow: 1,
    backgroundColor: theme.palette.common.white,
    margin: '80px 0px 0px 0px',
    padding: 0,
    overflow: 'hidden'
  }
}));

export default useNeoWrapperStyles;
